// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
//let commonUrl = "http://licai-jp.shop";
//let commonUrl = "https://jplc.rsok.top";
let commonUrl = "https://fsago.jpainisa.com";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl
